:host {
  display: block;

  .option {
    padding-left: 16px;
    padding-right: 16px;
    color: var(--text-color);
    font-size: var(--font-size);
    font-family: var(--font-family);
    height: 32px;
    line-height: 32px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .option:hover {
    transition: background-color 0.25s;
    background-color: var(--item-hover-color);
  }
  .option-selected {
    background-color: var(--item-active-color);
  }
  .option[disabled] {
    color: gray;
    cursor: default;
  }
  .option[disabled] ch-icon {
    filter: grayscale(100%);
  }
  .option[disabled]:hover {
    background-color: transparent;
  }
  .icon {
    display: inline-block;
    line-height: 0;
  }
  .left-icon {
    margin-inline-end: 8px;
  }
  .right-icon {
    margin-inline-start: 16px;
  }
  .left-container {
    display: flex;
    align-items: center; 
  }
}
